$shm_hitalama_version_label $mol_view
	version \
	date \
	available_version \
	outdated false
	sub /
		<= title \
	attr *
		^
		outdated <= outdated
